import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  providers: [MessageService],
})
export class RegisterComponent implements OnInit {

  userTypeList = [
    { label: "Select", value: "" },
    { label: "Admin", value: "admin" },
    { label: "Internal", value: "internal" },
    { label: "External", value: "external" },
  ]

  partnerNameList = [
    { label: "Select", value: "" },
    { label: "Walmart", value: "walmart123" },
    { label: "Amazon", value: "amazon123" },
  ]

  partnerIdList = [
    { label: "walmart123", value: "walmart123" },
    { label: "amazon123", value: "amazon123" },
  ]
  registrationForm: any;
  loader:boolean = false;
  constructor(private fb: FormBuilder, private httpClient: HttpClient,
    private router: Router, private messageService: MessageService,
    private http: HttpClient,) {

  }

  ngOnInit() {

    this.registrationForm = this.fb.group({
      fName: ['', Validators.required],
      lName: ['', Validators.required],
      // phnNum: ['', [Validators.required, Validators.maxLength(10)]],
      email: ['', [Validators.required, Validators.email]],
      secEmail: ['', Validators.email],
      // partnerName: ['', Validators.required],
    });
  }

  register() {
    if (this.registrationForm.invalid) {
      Object.keys(this.registrationForm.controls).forEach(field => {
        const control = this.registrationForm.get(field)
        control.markAsTouched()
      });
    } else {

      const req = {
        "firstName": this.registrationForm.value.fName,
        "lastName": this.registrationForm.value.lName,
        "email": this.registrationForm.value.email,
        "secondaryEmail": this.registrationForm.value.secEmail,
      }
      this.loader = true;
      this.httpClient.post(environment.apiUrl + "/user/register", req, { responseType: "text" })
      .subscribe({
        next: (res: any) => {
          this.loader = false;
          //console.log(res, "registration response");
          if (res.includes('Registartion successful')) {
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: "Registartion successfull.You will get an email with user/password once admin approves",              
            });
            this.registrationForm.reset();
          } else {
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Registration Failed",
            });
          }
        },
        error: (err) => {
          //console.error("Registration failed", err);
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "An error occurred while registering. Please try again.",
          });
        }
      });
    }
  }
  emailVerify(eve: any) {
    const emailValue = (eve.target as HTMLInputElement).value.trim();  
    if (emailValue !== '') {
      const params = new HttpParams().set('email', emailValue); 
        let headers = new HttpHeaders();
        headers =   headers.append("Content-Type", "application/text");      
       this.httpClient.get(`${environment.apiUrl}/user/registerd`, { params, responseType: 'text'})
        .subscribe(
          (res: any) => {
            //console.log(res, "Response from server");  
            if (res === 'You have already registered with this email ID.') {
              this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: res,
              });
              (eve.target as HTMLInputElement).value = '';
            }
          },
          error => {
            //console.error("Error occurred while verifying the email", error);
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "An error occurred while verifying the email. Please try again.",
            });
          }
        );
    }
  }
  
}